module.exports = __webpack_public_path__ + "images/productid.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/productid.png
// module id = 6H2r
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13